export default __webpack_public_path__ + "static/media/systemowe6.66bea117.jpg";